import React from "react";
import ProductVisual from "@/components/brand/ProductVisual";

/**
 * Shows the real Shift4Shop product image when a synced image URL is present,
 * otherwise falls back to the branded research-vial illustration.
 */
export default function ProductMedia({ product = {}, className = "", dark = true, imgClass = "" }) {
  if (product.image) {
    return (
      <div className={`relative overflow-hidden bg-white flex items-center justify-center ${className}`}>
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          className={`w-full h-full object-contain p-3 transition-transform duration-700 ease-out group-hover:scale-105 ${imgClass}`}
        />
      </div>
    );
  }
  return <ProductVisual name={product.name} className={className} dark={dark} />;
}
